// ----- banner search input ----- //
.ac-search-container {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;

    input[type=text] {
        height: 44px;
        font-size: 18px;
        padding-left: 48px;
        padding-right: 110px;
        background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi41IDMuNzVhOC43NSA4Ljc1IDAgMSAwIDAgMTcuNSA4Ljc1IDguNzUgMCAwIDAgMC0xNy41Wk0uMjUgMTIuNUMuMjUgNS43MzUgNS43MzUuMjUgMTIuNS4yNVMyNC43NSA1LjczNSAyNC43NSAxMi41YzAgMi43NTItLjkwNyA1LjI5MS0yLjQzOSA3LjMzNmw1LjQyNiA1LjQyN2ExLjc1IDEuNzUgMCAxIDEtMi40NzQgMi40NzRsLTUuNDI3LTUuNDI2QTEyLjE5NiAxMi4xOTYgMCAwIDEgMTIuNSAyNC43NUM1LjczNSAyNC43NS4yNSAxOS4yNjUuMjUgMTIuNVoiIGZpbGw9IiM1RjI0NzgiLz48L3N2Zz4=');
        background-size: 24px 24px;
        background-repeat: no-repeat;
        background-position: left 16px center;
        border: 2px solid $colour-primary-300;
        border-radius: 7.5px;
        padding-top: rem(14);
        box-shadow: $search-drop-shadow;

        &:focus-visible {
            outline: none;
        }

        &:focus {
            border-color: $colour-primary-500;
        }
    }

    .auto-complete-container {
        width: 100%;

        .search-results {
            border-bottom-right-radius: rem(12);
            border-bottom-left-radius: rem(12);
        }
    }

    .search-action-container {
        position: relative;
    }

    .search-actions {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        .reset-button {
            font-size: 0;
            padding: 0;
            border: none;
            background-color: transparent;
            cursor: pointer;

            svg path {
                fill: $core-neutral-900;
                transition: fill 0.2s linear;
            }

            &:disabled svg path, &[disabled] svg path {
                fill: $core-neutral-300;
            }
        }
    }
}

.checkbox-remember-details {
    display: flex;
    align-items: center;

    label {
        margin-top: 0.25rem;
        margin-left: 0.5rem;
    }
}

.grecaptcha-badge {
    visibility: hidden !important;
}
